export default __webpack_public_path__ + "static/media/men-3.407e636e.jpg";